import { connect, ConnectedProps } from 'react-redux';
import { useNavigate } from 'react-router';
import classNames from 'classnames';

import lang from '../../../../lib/language';
import { RootState } from '../../../../lib/store';
import { CloseoutCall } from '../../../../lib/store/closeout/types';
import { getCurrentAccountTradingPlan } from '../../../../lib/store/crm/helpers';
import { CRMCall } from '../../../../lib/store/crm/types';
import { PaymentCall } from '../../../../lib/store/payment/types';
import { isCallStatusPending } from '../../../../lib/util/error-handling/StatusByCallHelpers';

import { UI_ROUTES } from '../../../../util/routes';

import styles from './PlanContainer.module.scss';

const PlanContainer = (props: ReduxProps) => {
  const {
    tradingPlan,
    isTradingPlanPending,
    isPaymentsPending,
    isAccountCloseoutStatusPending,
  } = props;
  const isLoading = isPaymentsPending
    || isTradingPlanPending
    || isAccountCloseoutStatusPending;

  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div className={styles.loadingContainer}>
        <div className={styles.loadingItem} />
        <div className={styles.loadingItem} />
      </div>
    );
  }

  return (
    <div className={classNames([styles.container, { [styles.hiddenContainer]: !tradingPlan }])}>
      <div className={styles.titleContainer}>
        <div className={styles.title}>{tradingPlan?.phase}</div>
      </div>
      <div className={styles.planContainer}>
        <div className={classNames(styles.planInfo, { [styles.hiddenPlanInfo]: !tradingPlan })}>
          {tradingPlan && (
            <button
              type="button"
              className={styles.detailsButton}
              onClick={() => navigate(UI_ROUTES.planDetails)}
            >
              {lang.commonPlanDetails()}
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  tradingPlan: getCurrentAccountTradingPlan(state.crm),
  isPaymentsPending: isCallStatusPending(PaymentCall.getPaymentsAll, state.payment.statusByCall),
  isTradingPlanPending: isCallStatusPending(CRMCall.searchTradingPlans, state.crm.statusByCall),
  isAccountCloseoutStatusPending: isCallStatusPending(
    CloseoutCall.getAccountCloseoutStatus,
    state.closeout.statusByCall,
  ),
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(PlanContainer);
